import { Outlet } from 'react-router-dom';

import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

import { MissionsCategoryTabsLayout } from '@sorare/gameplay/src/components/missions/MissionsCategoryTabsLayout';

const FootballMissionsCategoryLayout = () => {
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const { sport } = useSportContext();

  return (
    <ConditionalWrapper
      Wrapper={MissionsCategoryTabsLayout}
      props={{ sport }}
      wrap={!isDesktopAndAbove}
    >
      <Outlet />
    </ConditionalWrapper>
  );
};

export default FootballMissionsCategoryLayout;
